import dayjs from "dayjs";

import type { DayCode } from "@/types/fhir";
import type { CalendarView, TimeRange, WeekSchedule } from "@/types/scheduling";

export const DAY_CODES: DayCode[] = [
  "mon",
  "tue",
  "wed",
  "thu",
  "fri",
  "sat",
  "sun",
];

export const CALENDAR_VIEWS: CalendarView[] = ["day", "week", "month"];

/**
 * Values are i18n keys — always pass through `t()` before rendering.
 */
export const DAY_SHORT_LABELS: Record<DayCode, string> = {
  mon: "Mon",
  tue: "Tue",
  wed: "Wed",
  thu: "Thu",
  fri: "Fri",
  sat: "Sat",
  sun: "Sun",
};

/**
 * Needs for i18next-scanner
 */
// t('Mon')
// t('Tue')
// t('Wed')
// t('Thu')
// t('Fri')
// t('Sat')
// t('Sun')

/**
 * Values are i18n keys — always pass through `t()` before rendering.
 */
export const DAY_LABELS: Record<DayCode, string> = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

/**
 * Needs for i18next-scanner
 */
// t('Monday')
// t('Tuesday')
// t('Wednesday')
// t('Thursday')
// t('Friday')
// t('Saturday')
// t('Sunday')

export const SCHEDULING_TIME_FORMAT = "HH:mm";
export const SCHEDULING_DISPLAY_TIME_FORMAT = "h:mma";
export const LOCAL_DATETIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const MIN_SLOT_DURATION = 5;

/**
 * The appointment-type code of a consultation block. `N` is its duration in
 * minutes. Bookings match on the code, so the code, not the block's
 * `duration`, is the block's identity.
 */
export const CONSULTATION_CODE_PATTERN = /^CONSULT-([1-9]\d*)-MIN$/;

/**
 * The durations a new consultation block may have, in minutes. Stored
 * blocks outside the range are listed and edited as they are.
 */
export const MIN_CONSULTATION_DURATION = 15;
export const MAX_CONSULTATION_DURATION = 120;
export const CONSULTATION_DURATION_STEP = 15;

/**
 * What the create dialog opens on when the schedule has no block of it yet
 */
export const DEFAULT_CONSULTATION_DURATION = 60;

/**
 * Total number of distinct calendar colors available.
 * Used for modulo assignment of colors to practitioner roles.
 */
export const CALENDAR_COLOR_COUNT = 10;

export const DEFAULT_RANGE: TimeRange = { start: "09:00", end: "18:00" };

export const DEFAULT_WEEK_SCHEDULE: WeekSchedule = {
  mon: { enabled: true, ranges: [DEFAULT_RANGE] },
  tue: { enabled: true, ranges: [DEFAULT_RANGE] },
  wed: { enabled: true, ranges: [DEFAULT_RANGE] },
  thu: { enabled: true, ranges: [DEFAULT_RANGE] },
  fri: { enabled: true, ranges: [DEFAULT_RANGE] },
  sat: { enabled: false, ranges: [DEFAULT_RANGE] },
  sun: { enabled: false, ranges: [DEFAULT_RANGE] },
};

export const WORKING_HOURS_OPTIONS = Array.from({ length: 48 }, (_, index) => {
  const time = dayjs()
    .startOf("day")
    .add(index * 30, "minute");

  return {
    value: time.format(SCHEDULING_TIME_FORMAT),
    label: time.format(SCHEDULING_DISPLAY_TIME_FORMAT),
  };
});
